var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconBuilding = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 40.43",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 505"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 504"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 575",
    d: "M13.51,45.22h8.84v-9h5.3v9h8.84V4.78h-23ZM26.61,9.55h5.31v5.31H26.61Zm0,8.53h5.31v5.31H26.61Zm0,8.53h5.31v5.31H26.61ZM18.08,9.55h5.3v5.31H18.07Zm0,8.53h5.3v5.31H18.07Zm0,8.53h5.3v5.31H18.07Z",
    transform: "translate(0 -4.78)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 576",
    d: "M38.55,8.4V37H42v8.23h8V8.4Zm7.29,24.71H41V28.28h4.84v4.83Zm0-7.77H41V20.51h4.84v4.83Zm0-7.76H41V12.74h4.84v4.83Z",
    transform: "translate(0 -4.78)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 577",
    d: "M0,45.22H8V37h3.41V8.4H0ZM4.16,12.74H9v4.83H4.16Zm0,7.77H9v4.83H4.16Zm0,7.76H9v4.84H4.16Z",
    transform: "translate(0 -4.78)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBuilding, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-building.8f2306da.svg";
export { ForwardRef as ReactComponent };